module.exports = __webpack_public_path__ + "static/img/you.88430ebb.png";